// AdminMarketerConsultantMobile.jsx — 마케터 1:1 관리 휴대폰 화면 (2026-10-06 UX 4단계)
//   제목·[변경 기록] → 회사 고르기 → 밑줄 탭(상단바 아래 붙음) → 탭 내용.
//   데이터·창은 PC와 같은 훅(vm·board·actions·calc)과 같은 창(MarketerConsultantModals)을 쓴다 — 그리기만 다르다.
import React from 'react';
import { CompanyTabs, MarketerConsultantTabs } from './MarketerConsultantTabs';
import { MobileAssignTab } from './mobile/MobileAssignTab';
import { MobileChargeTab } from './mobile/MobileChargeTab';
import { ConsultantSharePanel } from './ConsultantSharePanel';
import { PAGE_SUBTITLE } from './AdminMarketerConsultantPc';
import { M } from './mobile/mobile.styles';

export function AdminMarketerConsultantMobile({
  vm, board, actions, calc, history, today, tab, onTab, tabItems, integratedMenuId, pageTitle,
}) {
  return (
    <div style={M.page}>
      <div>
        <div style={M.headRow}>
          <h1 style={M.title}>{pageTitle}</h1>
          <div style={M.headBtns}>
            <button type="button" style={M.headBtn(false)} onClick={history.openAll}>변경 기록</button>
          </div>
        </div>
        <div style={M.sub}>{PAGE_SUBTITLE}</div>
      </div>

      <CompanyTabs vm={vm} styles={M} />

      <MarketerConsultantTabs tab={tab} onChange={onTab} pendingCount={calc.pendingChargeCount} items={tabItems} variant="underline" />

      {tab === 'assign' && <MobileAssignTab vm={vm} board={board} actions={actions} today={today} />}
      {tab === 'charge' && <MobileChargeTab calc={calc} actions={actions} integratedMenuId={integratedMenuId} />}
      {tab === 'share' && (
        <ConsultantSharePanel companyCode={vm.activeTab} companyName={vm.activeCompanyName} integratedMenuId={integratedMenuId} />
      )}
    </div>
  );
}
